{
  "mensagens": {
    "containerOperacoes": {
      "titulo": "Saldo Online",
      "subtitulo": "Confira as informações de saldo online das contas corrente que você possui cadastradas:",
      "descricaoSalvarOperacoesFuturas": "Salvar informações para operações futuras",
      "selecione": "Selecione",
      "verificacao": "Verifique",
      "inserir": "Insira"
    },
    "containerOperacoesAndamento": {
      "titulo": "Confirme suas Operações",
      "subtitulo": "Aqui você está em um ambiente seguro, pode criar sua lista para depois enviar para liquidação."
    },
    "containerOperacoesProcessadas": {
      "titulo": "Status das Operações",
      "subtitulo": "Aqui estão todas as operações enviadas do dia. É possível acompanhar o status interno de cada uma delas."
    },
    "dados_cliente": {
      "titulo": "Conta",
      "contaCorrente": "Conta Corrente",
      "contaInvestimento": "Agência",
      "cliente": "Selecione um Cliente",
      "separadorListaDeContas": "Contas",
      "agencia_conta": "Agência",
      "dac_conta": "Dígito/DAC",
      "cnpj": "CNPJ",
      "nomeCliente": "Nome do Cliente",
      "saldo": "Saldo online",
      "validacao": {
        "dadosNaoPreenchidos": "Dados do cliente não estão preenchidos",
        "dadosNaoDefinidos": "Dados do cliente não estão definidos",
        "contaCorrente": "Conta-Corrente",
        "agencia_conta": "Agência",
        "cnpj": "CNPJ",
        "nomeCliente": "Nome do cliente",
        "cnpjInvalido": "CNPJ inválido",
        "quantidadeDigitosAgencia": "A Agência deve conter no máximo cinco dígitos",
        "quantidadeDigitosContaCorrente": "A Conta Corrente deve conter no máximo vinte dígitos"
      }
    },
    "movimentacaoEtf": {
      "operacao": {
        "editOpTitulo": "Editar Operação",
        "novaOpTitulo": "Novas Operações",
        "editOpSubTitulo": "Para realizar a edição da operação preencha os campos abaixo:",
        "novaOpSubTitulo": "Para realizar uma nova operação preencha os campos abaixo:",
        "ETF": "Nome do ETF",
        "ISIN": "ISIN",
        "droptListInvestidor": "Investidor",
        "dropListOperacao": "Operação",
        "protocoloCBLC": "Protocolo CBLC",
        "qtdCestas": "Quantidade de cestas",
        "custoDiante": "Custodiante",
        "contaSelic": "Conta SELIC"
      },
      "filtro": {
        "ETF": "ETF",
        "investidor": "Investidor",
        "operacao": "Tipo",
        "sts_operacao": "Status"
      },
      "grid": {
        "ETF": "ETF",
        "Operacao": "Tipo",
        "ISIN": "ISIN",
        "Investidor": "Investidor",
        "Status": "Status",
        "ProtocoloCBLC": "CBLC",
        "QtdCestas": "Cestas",
        "Custodiante": "Custodiante",
        "Selic": "Selic",
        "Data": "Data"
      },
      "titulo": "ETFs",
      "subTitulo": "Aqui você pode realizar operações e consultas",
      "descricao": "Operações enviadas no dia podem ser canceladas ou editadas até 30min antes do fechamento da B3",
      "aviso": "Os ETFs estarão liberados para movimentações à partir das 09:30hs."
    },
    "operacao": {
      "titulo": "Operação",
      "tipo": "Tipo Operação",
      "codigo": "Codigo",
      "sub_conta": "Subconta",
      "valor": "Valor Operação",
      "nome_fundo": "Nome do Fundo",
      "operacaoAplicacao": "aplicacao",
      "operacaoResgateTotal": "resgate_total",
      "operacaoResgateParcial": "resgate_parcial",
      "validacao": {
        "fundoNaoLocalizado": "Fundos de Investimentos não localizados",
        "dadosNaoPreenchidos": "Dados da operação não estão preenchidos",
        "dadosNaoDefinidos": "Dados da operação não estão definidos",
        "tipo": "Tipo de operação",
        "sub_conta": "SubConta",
        "data": "Data de operação",
        "valorNaoNumerico": "O valor da operação deve ser preenchido apenas com numeros",
        "valorZerado": "o valor não deve ser preenchido",
        "valorMaiorZero": "o valor informado deve ser maior que zero",
        "valorMenorUmBilhao": "o valor informado deve ser menor que um bilhão",
        "valorMaiorZeroMenorUmBilhao": "O valor informado deve ser maior que 0 e menor que 1 bilhão",
        "nome_fundo": "Nome do fundo",
        "dataInvalida": "Data de operação não pode ser diferente de hoje",
        "relacaoResgateTotalEValorDaOperacao": "Para operações de resgate total o valor da operação não deve ser informado",
        "valorTipoOperacao": "O tipo da operação deve ser 'aplicacao', 'resgate_total', ou 'resgate_parcial'",
        "operacaoAplicacaoInvalida": "A operação do tipo 'tipo_aplicacao', mensagem_valor e mensagem_tipo_liquidacao"
      }
    },
    "liquidacao": {
      "titulo": "Liquidação",
      "tipo": "Tipo de Liquidação",
      "agencia_conta": "Agência",
      "botaoContaDestino": "Conta Destino",
      "banco": "Banco",
      "contaCorrente": "Conta Corrente",
      "digito_conta": "Digito",
      "tipoNenhuma": "nenhuma",
      "tipoTef": "tef",
      "tipoTed": "ted",
      "validacao": {
        "dadosNaoPreenchidos": "Dados de liquidação não estão preenchidos",
        "dadosNaoDefinidos": "Dados de liquidação não estão definidos",
        "tipo": "Tipo de liquidação",
        "agencia": "Agência de liquidação",
        "conta": "Conta corrente de liquidação",
        "banco": "Banco de liquidação",
        "nenhuma": "a liquidação deverá ser do tipo Nenhuma, com os dados bancários iguais aos do cliente",
        "ted": "a liquidação por TED, o dados bancários do destinatário devem ser diferente do cliente",
        "tef": "a liquidação por TEF, o banco destinatário deve ser o Banco Itaú e a conta diferente do cliente",
        "valorTipoLiquidacao": "O tipo da liquidação deve ser 'ted', 'tef', ou 'nenhuma'"
      }
    },
    "filtroUltimasOperacoes": {
      "titulo": "Últimas Operações"
    },
    "controleUploadArquivo": {
      "titulo": "UPLOAD DE ARQUIVO",
      "validacao": {
        "arquivoImportado": "Arquivo importado com sucesso, {0} registro(s) importado(s). Por favor, verifique a seção \"Confirme suas Operações\".",
        "arquivoCsvMultiplo": "Não é permitido o upload de mais de um arquivo",
        "formatoArquivoInvalido": "Arquivo fora do padrão aceito",
        "erroCarregamentoArquivo": "Ocorreram erros ao importar o arquivo",
        "erroArquivoVazio": "Atenção! O arquivo não possui registros para importação",
        "variasLinhasComErro": "Há inconsistências em uma ou mais linhas do arquivo. Veja abaixo:"
      }
    },
    "controleAdicionarOperacao": {
      "titulo": "ADICIONAR"
    },
    "controleEnviarOperacao": {
      "titulo": "ENVIAR"
    },
    "controleExcluirOperacao": {
      "titulo": "EXCLUIR"
    },
    "controleEnviarPorEmail": {
      "titulo": "ENVIAR POR EMAIL"
    },
    "controleExportar": {
      "titulo": "EXPORTAR"
    },
    "controleAtualizar": {
      "titulo": "Atualizar"
    },
    "controleModeloCsv": {
      "titulo": "Modelo CSV"
    },
    "gridOperacoes": {
      "totalOperacoes": "Total de Operações",
      "quantidade": "Qtd por página",
      "inconsistencias": "Inconsistências",
      "cabecalhoColunaConta": "Conta",
      "cabecalhoColunaTipo": "Tipo",
      "cabecalhoColunaValor": "Valor",
      "cabecalhoColunaValidacao": "Validação",
      "cabecalhoColunaStatus": "Status",
      "cabecalhoAcoes": "Ações",
      "operacoesSelecionadas": "operações selecionadas.",
      "semOperacoesEnviadas": "Não existem Operações Enviadas no momento."
    },
    "comuns": {
      "CNPJ": "CNPJ",
      "juncaoDe": "de",
      "juncaoPor": "por",
      "edicao": "Editar",
      "exclusao": "Excluir",
      "agencia": "Agência",
      "nome": "Fundo",
      "data": "Data",
      "dataHora": "Data/Hora",
      "salvar": "Salvar",
      "codigoBancoItau": "0341",
      "cotista": "Cotista",
      "servicoIndisponivel": "Serviço indisponível ou não acessível",
      "parametrosInvalidos": "Itens não encontrados com os parâmetros informados.",
      "camposObrigatorios": "* Campos obrigatórios"
    },
    "textoRodape": " A Itaú Asset Management é a denominação de segmento do Itaú Unibanco S.A. (CNPJ 60.701.190/0001-04) dedicado à gestão de fundos de investimento e carteiras administradas de clientes.\nConsultas, sugestões, reclamações, críticas, elogios e denúncias, utilize o SAC: 0800 728 0728, todos os dias, 24 horas, ou o canal Fale Conosco (www.itau.com.br). Se necessário contate a Ouvidoria Corporativa Itaú: 0800 570 0011 (em dias úteis das 9h às 18h) ou Caixa Postal 67.600, CEP 03162-971. Deficientes auditivos ou de fala, todos os dias, 24 horas, 0800 722 1722. ",
    "filtroOperacoesDiarias": {
      "hoje": "Hoje",
      "unidadeTemporal": "dias",
      "prefixo": "Últimos",
      "dataFiltroOperacao": "Data Filtro",
      "mensagemCalendario": "Favor clicar na data, para abertura do calendário"
    },
    "edicaoOperacao": {
      "titulo": "Modo de edição",
      "mensagemFecharEdicao": "Atenção! Todas as informações não salvas serão perdidas.",
      "mensagemConfirmacaoSalvarOperacaoEditada": "Deseja salvar as alterações realizadas?",
      "mensagemConfirmacaoExcluirOperacaoEditada": "Tem certeza que deseja excluir essa operação?",
      "mensagemOperacaoSalvaSucesso": "Operação salva com sucesso.",
      "mensagemOperacaoExcluidaSucesso": "Operação excluída com sucesso.",
      "mensagemOperacaoExcluidaFalha": "Ocorreu erro ao excluir a operação."
    },
    "servicoInvestimento": {
      "erroCnpj": "CNPJ inválido",
      "contaNaoEncontradaCnpj": "Nenhuma conta encontrada com o CNPJ informado.",
      "contaNaoEncontradaDadosBancarios": "Não foi possível validar os dados bancários informados",
      "erroNovaOperacaoNula": "Não é possível inserir uma nova operação vazia",
      "operacaoNaoEncontrada": "Nenhuma operação localizada com o Id informado",
      "idOperacaoNaoInformado": "Id da Operação não informado",
      "dataNaoInformada": "Data não informada",
      "semOperacoesEnviadas": "Não existem Operações Enviadas no momento.",
      "identificadorConta": "O identificador da conta está inválido",
      "agenciaEContaInvalidas": "Agência e conta corrente inválidas.",
      "segmentoNaoInformado": "Segmento não encontrado para esse cotista",
      "erroDI7": "Entrar em contato com Movimentação."
    },
    "novaOperacao": {
      "validacao": {
        "novaOperacaoNula": "Houve um problema ao preencher uma nova operação",
        "novaOperacaoIndefinida": "Nova operação não está definida",
        "aplicacaoComLiquidacaoDiferenteDeNenhuma": "Para operações de aplicação o tipo de liquidação deve ser nenhuma",
        "tefAgenciaEContaIguaisContaCliente": "Para liquidação por TEF a agência e conta corrente devem ser as mesmas do cadastro da conta do cliente"
      }
    },
    "feedBack": {
      "titulo": "Inconsistências do Arquivo",
      "descricaoErros": "O Arquivo selecionado não pode ser importado. Por favor verifique a(s) linha(s) do arquivo",
      "camposObrigatorios": "O(s) campo(s) lista_campos devem ser preenchido(s). "
    },
    "relatorios": {
      "formularioRelatorio": {
        "filtroPeriodo": {
          "titulo": "Nova Consulta",
          "labelBotaoPorPeriodo": "Por Período",
          "labelBotaoMensal": "Mensal",
          "tituloFiltroData": "Data",
          "labelPreposicaoA": "à"
        },
        "validacao": {
          "dataInicialVersusDataFinal": "Data inicial maior que a data final"
        }
      },
      "salvarConsultas": {
        "textoBotao": "SALVAR CONSULTA",
        "labelQuantidadeMaximaConsultaSalvasAtingida": "Você já possui 3 consultas salvas.",
        "labelErroRecuperarConsultasSalvas": "Não foi possível validar as consultas salvas.",
        "tituloDialog": "Salvar Consulta",
        "subTituloDialog": "Você poderá usar estas configurações em sua próxima consulta.",
        "mensagemFeedbackBotaoSalvar": "Salvando consulta",
        "labelinputPopupFeedback": "Nome da Consulta"
      },
      "informacaoDownloadRelatorios": {
        "labelMsgSucessoDownload": "Relatório gerado com sucesso. Arquivo foi salvo em seu diretório de downloads.",
        "labelMsgSucessoSolicitacao": "Solicitação gerada com sucesso. Selecione na lista abaixo o relatório para download.",
        "labelMsgSucessoSolicitacaoXml": "Solicitação gerada com sucesso. Selecione na lista abaixo o XML para download.",
        "labelBotaoNovaConsulta": "Nova Consulta",
        "labelLinkVerInconsistencias": "VER INCONSISTÊNCIAS",
        "labelLinkVerInconsistenciasXml": "VER ERRO / INCONSISTÊNCIAS",
        "labelMsgErroGerarRelatorio": "Não foi possível gerar a solicitação do relatório.",
        "labelMsgSucessoInconsistencia": "Relatório gerado, porém existem inconsistências.",
        "labelInformacaoDialogTituloErro": "Mensagem de Erro",
        "labelInformacaoDialogSubTituloErro": "Seu relatório não pode ser processado, verifique abaixo o que aconteceu:",
        "cabecalhoGridDialogErroRequisicao": "Erro"
      },
      "textoRodape": "Todas as informações disponibilizadas nesta página, independentemente da data de atualização, são meramente gerenciais, e, portanto, sujeitas a alterações, motivo pelo qual não devem ser utilizadas para cálculo de benefícios ou para fins contábeis.",
      "comuns": {
        "labelInformacaoDialogTitulo": "Inconsistências Encontradas",
        "labelInformacaoDialogSubTitulo": "Verifique abaixo os itens que estão com algum tipo de inconsistência:",
        "cabecalhoGridDialogCarteira": "Carteira",
        "cabecalhoGridDialogTipoErro": "Tipo de Erro",
        "cabecalhoGridDialogCodigo": "Código",
        "cabecalhoGridDialogCnpj": "CNPJ",
        "cabecalhoGridDialogMensagem": "Mensagem"
      }
    },
    "titulosRelatoriosConstabeis": {
      "tituloRelatoriosContabeis": "Relatórios Contábeis",
      "subtituloRelatoriosContabeis": "Aqui você poderá solicitar relatórios de acordo com sua necessidade."
    },
    "menu": {
      "descricaoHome": "Home",
      "linkHome": "home"
    },

    "menus": {
      "menu": [
        {
          "descricao": "Movimentações",
          "link": "movimentacao",
          "submenu": [
            {
              "permissao": "ASCSV",
              "descricao": "Operações",
              "link": "operacoes-upload"
            },
            {
              "permissao": "ASMOVETF",
              "descricao": "ETFs",
              "link": "movimentacoes-etf"
            },
            {
              "permissao": "ASMOVI",
              "descricao": "Saldo Online",
              "link": "saldo-online"
            }
          ]
        },
        {
          "descricao": "Relatórios",
          "link": "relatorios",
          "submenu": [
            {
              "permissao": "ASRLCONT",
              "descricao": "Relatórios Contábeis",
              "link": "relatorioscontabeis"
            },
            {
              "permissao": "RELGERAL",
              "descricao": "Relatórios Gerais",
              "link": "relatorios-gerais"
            },
            {
              "permissao": "ASRLCD",
              "descricao": "Carteira Diária",
              "link": "carteira-diaria"
            }
          ]
        },
        {
          "permissao": "ASXMLEXT",
          "descricao": "Extratos",
          "link": "extratos",
          "submenu": []
        },
        {
          "permissao": "ASXML",
          "descricao": "XML",
          "link": "xml",
          "submenu": []
        },
        {
          "descricao": "Administrativo",
          "link": "admin",
          "submenu": [
            {
              "permissao": "ASCADS",
              "descricao": "Operadores x Contas",
              "link": "operadoresporcontas"
            },
            {
              "permissao": "ASCADS",
              "descricao": "Operadores x Contas (Novo)",
              "link": "operadoresporcontasnovo"
            },
            {
              "permissao": "ASCADS",
              "descricao": "Gestão de Relatórios",
              "link": "relatorios-gerais-upload"
            },
            {
              "permissao": "ASINVETF",
              "descricao": "Cadastro de Investidor",
              "link": "investidor-etf"
            },
            {
              "permissao": "ASCADS",
              "descricao": "Cadastro de Fundos Exclusivos",
              "link": "fundos-exclusivos"
            }
          ]
        }
      ]
    },

    "formatoRelatorio": {
      "labelFormatos": "Formatos",
      "labelFormatoPdf": "PDF",
      "labelFormatoExcel": "Excel",
      "labelFormatoCSV": "CSV"
    },
    "servicoRelatoriosContabeis": {
      "idNaoEncontrado": "O Id não foi encontrado",
      "erroNoId": "Erro no Id",
      "consultaNaoEncontrada": "Consulta salva não localizada com o Id informado."
    },
    "carteirasEFundos": {
      "tituloCarteiras": "Selecione suas Carteiras",
      "tituloFundos": "Selecione seus Fundos",
      "labelAdicionarItem": "Adicionar",
      "labelRemoverItem": "Remover",
      "carteirasNaoEncontradas": "Carteiras não encontradas para o cliente.",
      "fundosNaoEncontrados": "Fundos não encontrados para o cliente.",
      "carregandoCarteiras": "Aguarde, carregando as carteiras",
      "carregandoFundos": "Aguarde, carregando os fundos",
      "carregandoRelatorios": "Aguarde, carregando os relatórios"
    },
    "consultaSalva": {
      "titulo": "Consultas Salvas",
      "naoExisteConsulta": "Nenhuma consulta salva até o momento",
      "tituloDialog": "Remover de suas Consultas Salvas?",
      "subTituloDialog": "Esta opção será removida das suas consultas salvas, não sendo possível utiliza-la novamente.",
      "nomeJaUtilizado": "Já existe uma consulta salva com o mesmo nome"
    },
    "relatoriosContainer": {
      "titulo": "Selecione os relatórios",
      "labelAdicionarItem": "Adicionar Relatório",
      "labelRemoverItem": "Remover Relatório",
      "botaoDownloadRelatoriosContabeis": "Download",
      "botaoTentarNovamenteRelatoriosContabeis": "TENTAR NOVAMENTE",
      "botaoGerarSolicitacaoDownloadRelatoriosContabeis": "GERAR RELATÓRIO(S)",
      "relatoriosNaoEncontrados": "Relatórios não encontrados para o cliente.",
      "emitirSolicitacao": "Gerando a Solicitação",
      "emitirPorcessamentoRelatorios": "Processando os Relatórios",
      "erroRequisicaoRelatorio": "Ocorreram erros ao realizar o download dos relatórios",
      "erroRequisicaoQuantidadeDeSolicitacao": "Foi atingido a quantidade de tentativas de download do relatório"
    },
    "selecaoItem": {
      "labelAdicionarTodos": "Adicionar Todos",
      "labelRemoverTodos": "Remover Todos"
    },
    "informacaoCarteiraRelatorioSelecionados": {
      "labelQuantidadeCarteirasSelecionadas": " Carteira(s) selecionada(s)",
      "labelQuantidadeFundosSelecionados": " Fundo(s) selecionado(s)",
      "labelQuantidadeRelatoriosSelecionadas": " Relatório(s) selecionado(s)"
    },
    "extracaoCarteiraFundo": {
      "labelExtrairPor": "Extrair Por",
      "btnCarteira": "Carteira",
      "btnFundo": "Fundo",
      "btnFundoAberto": "Fundo Aberto",
      "btnFundoExclusivo": "Fundo Exclusivo"
    },
    "extratos": {
      "linkExtratos": "extratos",
      "titulo": "Extratos",
      "subTitulo": "Aqui você consegue solicitar os extratos de suas contas e fundos.",
      "configureExtrato": "Configure o extrato desejado",
      "selecioneOpcaoExtrato": "Selecione uma das opções acima para exibir os dados disponíveis.",
      "labelContasSelecionadas": " Conta(s) selecionada(s)",
      "labelBotaoExportarExtratos": "EXPORTAR",
      "labelSelecaoDataMensal": "Selecione o mês desejado para visualizar o extrato.",
      "labelSelecaoDataDiario": "Período disponível para consulta: 180 dias.",
      "opcoesExtrato": {
        "labelTituloOpcoesExtrato": "Opções",
        "labelBtnDetalhamentoAplicacao": "Detalhamento da Aplicação",
        "labelBtnDetalhamentoResgate": "Detalhamento de Resgate",
        "labelBtnExtratoDiario": "Extrato Diário",
        "labelBtnExtratoMensal": "Extrato Mensal"
      },
      "filtroPeriodo": {
        "titulo": "Consulta",
        "labelBotaoDiario": "Diário",
        "labelBotaoMensal": "Mensal"
      },
      "periodoExtrato": {
        "tituloData": "Data",
        "tituloPeriodo": "Período"
      },
      "contas": {
        "titulo": "Contas disponíveis para consulta",
        "colunaVisualizar": "Consulta",
        "colunaAgencia": "Agência",
        "colunaConta": "Conta",
        "colunaEmpresa": "Empresa",
        "colunaCnpj": "CNPJ",
        "semContasGrid": "Você não possui nenhuma conta vinculada ao seu perfil.",
        "linkVisualizar": "Visualizar",
        "tituloFeedbackVisualizar": "Visualização Extrato",
        "pesquisaCnpj": "Pesquisar Contas por CNPJ"
      },
      "servicoExtratos": {
        "idNaoEncontrado": "O Id não foi encontrado"
      },
      "exportacao": {
        "feedbackExportacaoSucesso": "Exportação do extrato realizada com sucesso",
        "mensagemFeedbackErroDownload": "Falha ao realizar o download. Por favor, tente novamente.",
        "mensagemFeedbackExportacaoParcial": "Extrato gerado parcialmente.",
        "labelLinkVerInconsistencias": "VER CONTAS COM INCONSISTÊNCIA",
        "tituloContasErros": "Inconsistências na geração do extrato",
        "subTituloContasErros": "Não foi possível gerar o extrato para as seguintes contas:",
        "colunaAgencia": "Agência",
        "colunaConta": "Conta-Dígito",
        "colunaMensagem": "Mensagem"
      }
    },
    "xml": {
      "titulo": "XML",
      "subTitulo": "Aqui você consegue solicitar os relatórios XML.",
      "aviso": "Para problemas relacionados a defasagem do gestor, entrar em contato com o atendimento Asset pelo telefone (11) 3631-2555.",
      "configure": "Configure o arquivo XML desejado",
      "selecioneOpcao": "Selecione as opções acima para exibir os dados disponíveis.",
      "labelCarteirasFundosSelecionados": " Carteira(s)/Fundo(s) selecionado(s).",
      "consulta": {
        "titulo": "Consulta",
        "labelBtnDiario": "Diário",
        "labelBtnMensal": "Mensal"
      },
      "opcoesXml": {
        "titulo": "Opções",
        "btnPosicao_4_0": "Posição 4.0",
        "btnPosicao_5_0": "Posição 5.0"
      },
      "periodo": {
        "titulo": "Data",
        "mensagemSelecaoDataMensal": "Período disponível: %d meses.",
        "avisoDataMensal": "O arquivo XML validado do mês anterior será disponibilizado a partir do sexto dia útil do mês corrente, respeitando a defasagem do gestor.",
        "mensagemSelecaoDataDiario": "Período disponível: %d dias.",
        "avisoDataDiario": "O arquivo XML diário será disponibilizado com dados do último dia útil, respeitando a defasagem do gestor."
      },
      "listaDeCarteiras": {
        "titulo": "Selecione os fundos e carteiras desejados:",
        "colunaNome": "Nome",
        "colunaCnpj": "CNPJ",
        "colunaCodigoFySac": " Cód. do Fundo (SAC/FY)",
        "colunaStatusCarteira": "Status",
        "colunaDefasagem": "Defasagem",
        "colunaDefasagemGestor": "Defasagem do gestor",
        "ultimoDiaDisponivel": "Último dia disponível",
        "ultimoMesDisponivel": "Último mês disponível:",
        "semRegistros": "Não existem fundos ou carteiras para o filtro selecionado.",
        "placeholderFiltro": "Pesquisar",
        "erroCritico": "Não foi possível consultar a lista de carteiras."
      },
      "centralDownload": {
        "botaoDownload": "DOWNLOAD",
        "botaoTentarNovamente": "TENTAR NOVAMENTE",
        "botaoGerarSolicitacaoDownload": "GERAR XML",
        "emitirSolicitacao": "Gerando a Solicitação",
        "emitirPorcessamentoRelatorios": "Processando os Relatórios"
      }
    },
    "home": {
      "titulo": "Bem-vindo ao site logado da Asset",
      "subtitulo": "As informações disponibilizadas no site estão sujeitas a alterações.",
      "textoRodape": "A Itaú Asset Management é a denominação de segmento do Itaú Unibanco S.A. (CNPJ 60.701.190/0001-04) dedicado à gestão de fundos de investimento e carteiras administradas de clientes.\nConsultas, sugestões, reclamações, críticas, elogios e denúncias, utilize o SAC: 0800 728 0728, todos os dias, 24 horas, ou o canal Fale Conosco (www.itau.com.br). Se necessário contate a Ouvidoria Corporativa Itaú: 0800 570 0011 (em dias úteis das 9h às 18h) ou Caixa Postal 67.600, CEP 03162-971. Deficientes auditivos ou de fala, todos os dias, 24 horas, 0800 722 1722."
    },
    "compartilhado": {
      "rodape": {
        "endereco": "Escritório: Av. Brigadeiro Faria Lima, 3500 - 5º andar - CEP: 04538-132 - São Paulo - SP",
        "linkPoliticaPrivacidade": "Termos de uso e privacidade",
        "anoDireitosAutorais": "2019",
        "textoRodape": "A Itaú Asset Management é a denominação de segmento do Itaú Unibanco S.A. (CNPJ 60.701.190/0001-04) dedicado à gestão de fundos de investimento e carteiras administradas de clientes.\nConsultas, sugestões, reclamações, críticas, elogios e denúncias, utilize o SAC: 0800 728 0728, todos os dias, 24 horas, ou o canal Fale Conosco (www.itau.com.br). Se necessário contate a Ouvidoria Corporativa Itaú: 0800 570 0011 (em dias úteis das 9h às 18h) ou Caixa Postal 67.600, CEP 03162-971. Deficientes auditivos ou de fala, todos os dias, 24 horas, 0800 722 1722."
      }
    },
    "login": {
      "subTituloLabel": "Acesse com sua conta institucional",
      "ebusinessLabel": "E-business ID",
      "ebusinessPlaceholder": "Insira E-business ID",
      "senhaLabel": "Senha",
      "senhaPlaceholder": "Insira sua senha",
      "novaSenhaLabel": "Nova senha",
      "novaSenhaPlaceholder": "Insira uma Nova senha",
      "confirmaNovaSenhaLabel": "Confirma nova senha",
      "confirmaNovaSenhaPlaceholder": "Insira a nova senha",
      "btnAcessar": "Acessar",
      "btnTrocarSenha": "Trocar a senha de acesso",
      "btnConfirmarTrocaSenha": "Confirmar",
      "btnCancelarTrocaSenha": "Cancelar",
      "erroNovaSenha": "A nova senha deve ser diferente da senha atual.",
      "erroConfirmacaoNovaSenha": "Confirmação de senha inválida.",
      "mensagemConfirmacaoTrocaSenha": "Senha alterada com Sucesso.",
      "servico": {
        "parametrosInvalidos": "Parâmetros inválidos para autenticação",
        "erroComunicacao": "Houveram problemas na autenticação. Entrar em contato com Movimentação.",
        "erroCredenciaisInvalidas": "E-business ID ou senha inválidos.",
        "erroSenhaExpirada": "Senha expirada. Realize a troca da senha.",
        "erroGenerico": "Não foi possível realizar o login. Tente novamente.",
        "erroGenericoTrocaSenha": "Não foi possível alterar a senha. Tente novamente.",
        "erroRecaptcha": "Não foi possível realizar o login. Tente novamente."
      },
      "tokenJwt": {
        "tituloFeedback": "Sessão Inválida",
        "subTituloFeedback": "Favor efetuar o login novamente"
      }
    },
    "charon": {
      "parametrosInvalidos": "Parâmetros inválidos para a requisição do router",
      "nomeOperacaoInvalida": "Requisição solicitada não encontrada",
      "erroExecucaoOperacao": "Erro ao executar a requisição solicitada"
    },
    "navBarInformacoes": {
      "saudacao": "Olá,",
      "logout": "logout"
    },
    "centralDownload": {
      "titulo": "Relatórios Gerados",
      "totalOperacoes": "Total de Solicitações",
      "semSolicitacoes": "Nenhuma solicitação de geração de relatório encontrada.",
      "semSolicitacoesXml": "Nenhuma solicitação de geração de XML encontrada.",
      "periodo": "Período",
      "posicao4": "Posição 4.0",
      "posicao5": "Posição 5.0",
      "diario": "Diário",
      "mensal": "Mensal",
      "tabelaColunas": {
        "hora": "Hora",
        "consulta": "Consulta",
        "formato": "Formato",
        "posicao": "Posição",
        "extraidoPor": "Extraído por",
        "dataSelecionada": "Data Selecionada",
        "status": "Status"
      },
      "labelBotaoAbrirCentralDownload": "Central de downloads",
      "labelLinkVerInconsistencias": "Ver inconsistências",
      "mensagemTentativas": "Ocorreu um erro na busca, tentando novamente. Tentativa",
      "erroGeralDeTentativas": "Desculpe, tivemos uma falha na busca das solicitações.",
      "labelBotaoTenteNovamente": "Tentar novamente",
      "juncaoDe": "de",
      "labelQuantidadeCarteirasFundosSelecionadas": " Carteira(s)/Fundos(s) selecionada(s)",
      "labelQuantidadeRelatoriosSelecionadas": " Relatório selecionado",
      "botaoGerarSolicitacaoDownloadRelatoriosContabeis": "GERAR RELATÓRIO(S)"
    },
    "operadoresPorContas": {
      "principal": {
        "tituloOperadoresPorContas": "Operadores por Contas",
        "subtituloOperadoresPorContas": "Aqui você poderá cadastrar os vínculos de operadores por contas correntes",
        "mensagemZeroRegistros": "Não há registro para ser exibido."
      },
      "containerOperadorEmpresa": {
        "titulo": "Consulta da Empresa",
        "tituloTabela": "Listagem de Operadores",
        "componenteBuscaOperadores": {
          "tituloCnpj": "CNPJ da Empresa",
          "insiraCnpjEmpresa": "Insira CNPJ da empresa",
          "tituloNomeEmpresa": "Razão Social",
          "verifique": "Verifique",
          "textoBotaoBuscar": "Buscar"
        },
        "componenteListaDeOperadores": {
          "tituloAcao": "Ações",
          "acaoEditar": "editar",
          "tituloRazaoSocial": "Razão Social",
          "tituloCnpj": "CNPJ",
          "tituloNomeOperador": "Nome",
          "tituloQtdeContas": "Qtde. Contas",
          "tituloEbusinessOperador": "Identificador"
        },
        "componenteListaDeContasPorOperador": {
          "contasVinculadas": "Contas Vinculadas",
          "cabecalhoCotista": "Cotista",
          "cabecalhoCNPJ": "CPF / CNPJ",
          "cabecalhoAgencia": "Agência",
          "cabecalhoConta": "Conta",
          "cabecalhoDigito": "Digito",
          "cabecalhoCodigoSAC": "Código SAC",
          "cabecalhoPerfil": "Perfil",
          "feedbackAoBuscarContas": "Não há registro para ser exibido."
        }
      },
      "containerContaOrigem": {
        "titulo": "Dados de Contas Origem",
        "componenteBuscaContas": {
          "tituloCnpj": "Pesquisar contas po CNPJ",
          "insiraCnpjEmpresaCliente": "CNPJ",
          "tituloNome": "Pesquisar contas por nome",
          "insiraNomeEmpresaCliente": "Nome",
          "tituloCodigoSac": "Pesquisar contas por cód. SAC",
          "insiraCodigoSacEmpresaCliente": "Código SAC"
        },
        "componenteListaDeContas": {
          "tituloTitular": "Titular",
          "tituloCnpj": "CNPJ",
          "tituloBanco": "Banco",
          "tituloAgencia": "Agência",
          "tituloConta": "Conta",
          "tituloDac": "Dígito",
          "tituloPerfil": "Perfil"
        },
        "dadosCadastrais": {
          "titulo": "Dados Cadastrais",
          "lblBanco": "Banco",
          "phTxtBanco": "Itaú",
          "lblAgencia": "Agência",
          "phTxtAgencia": "Insira",
          "lblConta": "Conta",
          "phTxtConta": "Insira",
          "lblDac": "Dígito/DAC",
          "phTxtDac": "Insira",
          "lblTitular": "Titular",
          "phTxtTitular": "Verificar",
          "btnAdicionar": "ADICIONAR"
        },
        "vincular": {
          "labelBotao": "VINCULAR",
          "tituloDialog": "Vincular Contas Correntes",
          "subTituloDialog": "Tem certeza que deseja vincular esta(s) conta(s) à empresa {emp}?",
          "feedBackSucessoContasVinculadas": "Conta(s) vinculada(s) com sucesso.",
          "feedBackFalhaContasVinculadas": "Ocorreu erro ao vincular todas as contas.",
          "feedBackSucessoParcialContasVinculadas": "Ocorreram erros ao vincular as seguintes contas: "
        },
        "excluir": {
          "labelBotao": "DESVINCULAR",
          "tituloDialog": "Desvincular Contas Correntes",
          "subTituloDialog": "Tem certeza que deseja desvincular estas contas?",
          "feedBackFalhaContasDesvinculadas": "Ocorreu erro ao desvincular todas as contas.",
          "feedBackSucessoParcialContasDesvinculadas": "Ocorreram erros ao desvincular as seguintes contas: "
        }
      },
      "mensagensErro": {
        "cnpjInvalido": "O CNPJ informado é inválido",
        "empresaInexistente": "Não existe empresa cadastrada com este CNPJ",
        "contaNaoPreenchida": "Dados da Conta Corrente não informados",
        "contaNaoSelecionada": "Conta de origem não informada",
        "cnpjEmpresaNaoPreenchida": "CNPJ da empresa não informado",
        "identificadorOperadorNaoPreenchido": "Identificador do operador não informado.",
        "erroCarregarSegmentos": "Erro ao carregar segmentos. Tente novamente.",
        "semSegmentos": "Nenhum segmento disponível.",
        "sucessoAtualizarEmpresa": "Empresa atualizada com sucesso!",
        "erroAtualizarEmpresa": "Erro ao atualizar empresa. Tente novamente."
      }
    },
    "selecaoContas": {
      "erroListarContas": "Ocorreu erro ao listar as contas.",
      "selecione": "Selecione",
      "labelDadosBancarios": "Dados Bancários"
    },
    "operacoesUpload": {
      "titulo": "Operações",
      "subTitulo": "Aqui você pode realizar suas operações pela tela ou planilha.",
      "statusBoletaIncorreto": "Inválido",
      "labelOperacoesSelecionadas": "Operação(ões) selecionada(s).",
      "statusBoleta": [
        "Processando",
        "Em Elaboração",
        "Em Aprovação",
        "Em Processamento",
        "Concluído",
        "Excluído",
        "Devolvido BackOffice",
        "Devolvido Aprovador",
        "Pendente Passivo",
        "Pendente Conta",
        "Cancelada"
      ],
      "statusOperacaoIncorreto": "Inválido",
      "statusOperacao": {
        "1": "Em Análise",
        "2": "Erro",
        "3": "Duplicado",
        "7": "Em Elaboração",
        "8": "Em Aprovação",
        "9": "Em Processamento",
        "10": "Concluído",
        "11": "Excluído",
        "12": "Devolvido BackOffice",
        "13": "Devolvido Aprovador",
        "14": "Pendente Passivo",
        "15": "Pendente de Conta",
        "16": "Cancelada",
        "17": "Concluído Parcial",
        "18": "Erro Termos Pendentes",
        "19": "Erro - Termo Assinado"
      },
      "tipoOperacaoIncorreta": "Inválido",
      "tipoOperacoes": ["Aplicação", "Resgate"],
      "operacoes": {
        "filtros": {
          "cotista": "Cotista",
          "tipo": "Tipo de Operação",
          "status": "Status",
          "dataInicio": "Data Início",
          "dataFim": "Data Fim",
          "codigoOp": "Cód. Op",
          "origem": "Origem",
          "codigoFundo": "Cód. Fundo",
          "fundo": "Fundo",
          "tipoLiquidacao": "Tipo de Liquidação",
          "contaLiquidacao": "Conta Liquidação",
          "operador": "Operador",
          "nomeArquivo": "Nome do arquivo"
        },
        "lista": {
          "colunaData": "Data",
          "colunaCodOp": "Cód. Op",
          "colunaCotista": "Cotista",
          "colunaTipo": "Tipo",
          "colunaTipoLiquidacao": "Liquidação",
          "colunaContaLiquidacao": "Conta Liq.",
          "colunaContaOperacao": "Conta Op.",
          "colunaContaOperacaoCarteira": "Carteira",
          "colunaCodFundo": "Cód. Fundo",
          "colunaFundo": "Fundo",
          "colunaValor": "Valor",
          "colunaStatus": "Status",
          "colunaOperador": "Operador",
          "colunaOrigem": "Origem",
          "colunaAcoes": "Ações"
        },
        "detalhesOperacao": {
          "abaDetalhes": {},
          "abaStatusPacs": {
            "tabela": {
              "colunaPac": "PAC",
              "colunaAquisicao": "Aquisição",
              "colunaAtivo": "Ativo",
              "colunaVencimento": "Vencimento",
              "colunaTaxa": "Taxa (a.a)",
              "colunaQtdVendida": "Qtd Vendida",
              "colunaValorEstimado": "PU Estimado",
              "colunaValorEfetuado": "PU Efetuado",
              "colunaTotalEstimado": "Total Estimado",
              "colunaTotalEfetuado": "Total Efetuado",
              "colunaStatus": "Status"
            }
          }
        }
      },
      "novasOperacoes": {
        "criarOp": {
          "titulo": "Operações",
          "subtituloFundos": "Aqui você pode realizar movimentações em fundos",
          "subtituloCarteiras": "Aqui você pode realizar movimentações em carteiras",
          "cotistaLabel": "Cotista",
          "contaLabel": "Conta",
          "fundoLabel": "Fundo",
          "subContaFundoLabel": "Subconta",
          "horarioFechamentoFundoLabel": "Horário Fechamento",
          "saldoLabel": "Saldo Disponível",
          "cotaFundoLabel": "Cota",
          "dataBaseLabel": "Data Base",
          "valorOperacaoLabel": "Valor da Operação",
          "carteiraAdministradaLabel": "Cart.Admin.",
          "tipoOperacaoLabel": "Tipo de Operação",
          "tipoLiquidacaoLabel": "Tipo de Liquidação",
          "contaLiquidacaoLabel": "Conta para Liquidação",
          "taxaPlLabel": "Tx Distrib. PL",
          "taxaPerfLabel": "Tx Distrib. Perf"
        },
        "tabelaNovasOps": {
          "colunaCotista": "Cotista",
          "colunaContaOperacao": "Conta Op.",
          "colunaContaOperacaoCarteira": "Carteira",
          "colunaTipo": "Tipo",
          "colunaLinha": "Linha",
          "colunaTipoLiquidacao": "Liq.",
          "colunaCodFundo": "Cód. Fundo",
          "colunaFundo": "Fundo",
          "colunaSubContaFundo": "Subconta",
          "colunaContaLiquidacao": "Conta Liq.",
          "colunaValor": "Valor",
          "colunaTaxaFundoPl": "Tx Dist. PL",
          "colunaTaxaFundoPerf": "Tx Dist. Perf",
          "colunaStatus": "Status",
          "colunaAcoes": "Ações"
        },
        "modalPac": {
          "tabela": {
            "colunaAtivo": "Ativo",
            "colunaPac": "PAC",
            "colunaAquisicao": "Aquisição",
            "colunaVencimento": "Vencimento",
            "colunaTaxa": "Taxa",
            "colunaQtdDisponivel": "Qtd Disponível",
            "colunaValorPapel": "PU Estimado",
            "colunaQtdVender": "Qtd a vender",
            "colunaTotalVender": "Total a vender"
          }
        }
      },
      "enviarPopup": {
        "titulo": "Upload de Arquivo",
        "tituloComAplicacoes": "Confirme o aceite das taxas para suas aplicações abaixo:",
        "btnUpload": "Upload de Arquivo",
        "btnCancelar": "Cancelar",
        "btnEnviar": "Enviar",
        "btnEnviando": "Enviando",
        "btnFechar": "Fechar",
        "msgSucesso": "Acompanhe a importação e o status das ordens pela tela de histórico.",
        "msgErro": "Houve erro ao enviar o arquivo.",
        "msgErroSubtitulo": "Intermitência no upload de arquivo, siga as instruções abaixo:",
        "msgErroDescription": "Informamos que, em situações específicas, o upload de planilhas pode apresentar instabilidade, resultando em mensagens de erro após o envio. Caso receba uma mensagem de erro durante o processo, solicitamos que entre em contato com a movimentação Asset (movimentacaoasset@itau-unibanco.com.br) antes de realizar uma nova importação, a fim de confirmar o status das operações e evitar duplicidades.",
        "invalidExtensionDescription": "Arquivo inválido. Apenas arquivos com a extensão \".CSV\" são aceitos.",
        "dataLabel": "Data",
        "nomeClienteLabel": "Cliente",
        "fundoLabel": "Fundo / Subconta",
        "tipoOperacaoLabel": "Tipo de Operação",
        "valorLabel": "Valor",
        "statusLabel": "Status"
      },
      "tabelaHistorico": {
        "titulo": "Histórico de arquivos recebidos",
        "colunaNome": "Nome",
        "colunaData": "Data",
        "colunaOperador": "Operador",
        "colunaStatusRecebimento": "Status Recebimento",
        "colunaAcao": "Ação",
        "statusErroLabel": "Erro",
        "statusSucessoLabel": "Sucesso",
        "statusPendenteLabel": "Em Processamento",
        "statusParcialLabel": "Parcial",
        "acaoDetalheLabel": "Detalhes",
        "inputPlaceholder": "Pesquisar arquivos",
        "listaVazia": "Você ainda não tem nenhum arquivo no histórico",
        "filtroSemResultado": "Nenhum arquivo encontrado",
        "errorDescricao": "Tente novamente",
        "errorDownloadDescricao": "Não foi possível realizar o download.",
        "buscarCnpjLabel": "Buscar por CNPJ",
        "buscarNomeArquivoLabel": "Nome do arquivo",
        "buscarOperadorLabel": "Operador",
        "buscarStatusLabel": "Status"
      },
      "detalhesOperacao": {
        "titulo": "Detalhes",
        "errorDescription": "Ocorreu um erro ao obter os detalhes dessa importação",
        "btnFechar": "Fechar",
        "statusSucesso": "Recebido com sucesso",
        "statusErro": "Problemas no recebimento",
        "registrosLabel": "Registros",
        "operacaoLabel": "Operação",
        "nomeCotistaLabel": "Nome do Cotista",
        "agenciaLabel": "Agência",
        "contaLabel": "Conta",
        "dacLabel": "Dígito",
        "tipoLabel": "Tipo",
        "valorOperacaoLabel": "Valor",
        "codigoFyLabel": "Cód. Fundo",
        "statusDasOrdensLabel": "Status",
        "detalheImportacaoLabel": "Detalhes",
        "cnpjLabel": "CPF/CNPJ",
        "numeroBoletaLabel": "Número Boleta",
        "maisInformacoesLabel": "Mais informações",
        "aplicacao": "Aplicação",
        "resgate": "Resgate",
        "resgateParcial": "Resgate parcial",
        "resgateTotal": "Resgate total",
        "realocacao": "Realocacao",
        "rendaFixa": "Renda fixa",
        "rendaVariavel": "Renda variável",
        "transferenciaContas": "Transfêrencia contas",
        "situacaoLabel": "Situação"
      },
      "downloadOperacoes": {
        "msgLimiteOperacoes": "O limite de 100 arquivos por download foi excedido.",
        "msgErroRealizarDownload": "Erro ao tentar realizar o download das operações.",
        "msgNenhumaOperacaoSelecionada": "Nenhuma operação foi selecionada."
      }
    },

    "carteiraDiaria": {
      "titulo": "Carteira Diária",
      "subTitulo": "Aqui é possível consultar a composição de ativos vinculados a carteira administrada ou fundos que você possui posição.",
      "listaDeCarteiras": {
        "titulo": "Selecione os fundos e carteiras desejados",
        "colunaNome": "Nome",
        "colunaCnpj": "CNPJ",
        "colunaCodigoFySac": " Cód. do Fundo (SAC/FY)",
        "colunaStatusCarteira": "Status",
        "colunaDefasagemGestor": "Defasagem do gestor",
        "semRegistros": "Não existem fundos ou carteiras para o filtro selecionado.",
        "placeholderFiltro": "Pesquisar",
        "erroCritico": "Não foi possível consultar a lista de carteiras."
      },
      "dataInvalida": "Data inválida. Por favor, verifique.",
      "textoInformativo": "Este relatório está atualizado somente até d-1 da data atual, limitado aos últimos 18 meses. Em caso de dúvidas, entre em contato com o atendimento Asset pelo telefone: (11) 3631-2555."
    },

    "investidorEtf": {
      "codigoCblc": "Código CBLC",
      "cnpj": "CNPJ",
      "cpf": "CPF",
      "segmento": "Segmento",
      "novoCadastro": "Novo Cadastro",
      "situacaoFiscal": "Situação Fiscal",
      "razaoSocial": "Razão Social",
      "nomeInvestidor": "Nome Investidor",
      "nacionalidade": "Nacionalidade",
      "dataNascimento": "Data Nascimento",
      "custodiante": "Custodiante",
      "contaSelic": "Conta Selic",
      "titulo": "Novo Cadastro",
      "subTitulo": "Esta função permite o cadastro de novos investidores",
      "tituloEditar": "Editar Cadastro",
      "subTituloEditar": "Esta função permite a edição investidores"
    }
  }
}
